import { IFooterModel } from 'models/IFooterModel';
import { RedFooterModel } from 'models/RedFooterModel';
import { PageState } from 'models/PageState';
import { ApiVersion } from 'models/ApiVersion';
import { initialState, legacyFooter } from './reducer';
import { FooterModel } from 'models/FooterModel';

const isRedFooter = (footer: IFooterModel): footer is RedFooterModel =>
  footer.version === ApiVersion.RD3;

export const getRedFooter = (state: PageState): RedFooterModel => {
  if (!isRedFooter(state.footer)) {
    return initialState;
  }

  return state.footer;
};

const isLegacyFooter = (footer: IFooterModel): footer is FooterModel =>
  footer.version === ApiVersion.Legacy;

export const getLegacyFooter = (state: Pick<PageState, 'footer'>): FooterModel => {
  if (!isLegacyFooter(state.footer)) {
    return legacyFooter;
  }

  return state.footer;
};
